import { render, staticRenderFns } from "./AlertProfileInvest.vue?vue&type=template&id=2ca0cfe4&scoped=true&"
import script from "./AlertProfileInvest.vue?vue&type=script&lang=ts&"
export * from "./AlertProfileInvest.vue?vue&type=script&lang=ts&"
import style0 from "./AlertProfileInvest.vue?vue&type=style&index=0&id=2ca0cfe4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca0cfe4",
  null
  
)

export default component.exports